import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonType } from '../button';
import {
  NavigationAndActionArrowBack,
  NavigationAndActionArrowForth,
} from '../icons';
import { ToggleButton, ToggleButtonType } from '../toggleButton';
import {
  StyledPageList,
  StyledPaginationContainer,
  StyledTableFooter,
} from './styled';
import { DOTS, usePagination } from './usePagination';
import { setCheckedBills } from '../../billsPage/redux/slice';
import { useAppDispatch } from '../../hooks/appHooks';

export interface PaginationProps {
  maxPages?: number;
  currentPage?: number;
  totalBills?: number;
  showPaginationHelp?: boolean;
  onPageChange?: (page: number) => any;
  onRowCountChange?: (page: number) => any;
  className?: string;
}

export const Pagination: React.FC<PaginationProps> = ({
  maxPages = 1,
  currentPage = 1,
  totalBills = 0,
  showPaginationHelp,
  onPageChange,
  onRowCountChange,
  className,
}) => {
  const paginationRange = usePagination(currentPage, maxPages);
  const tableRowCountPerPage = [10, 20, 50, 100];
  const [currentRowCount, setCurrentRowCount] = useState(10);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  return (
    <StyledTableFooter>
      {showPaginationHelp === true ? (
        <div>
          <StyledPageList>
            {t('tableFooter.countPerPagePlaceholder')}
            {tableRowCountPerPage.map((tableRowCount) => (
              <li key={tableRowCount}>
                <ToggleButton
                  type={ToggleButtonType.Text}
                  text={tableRowCount.toString()}
                  toggled={tableRowCount === currentRowCount}
                  onClick={() => {
                    setCurrentRowCount(tableRowCount);
                    onRowCountChange &&
                      onRowCountChange(tableRowCount as number);
                    dispatch(setCheckedBills([]));
                  }}
                />
              </li>
            ))}
          </StyledPageList>
          <StyledPageList>
            {t('tableFooter.countPerPageTextP1')}
            {`${(currentPage - 1) * currentRowCount + 1}-${
              currentPage * currentRowCount > totalBills
                ? totalBills
                : currentPage * currentRowCount
            }`}
            {t('tableFooter.countPerPageTextP2')}
            {totalBills}
            {t('tableFooter.countPerPageTextP3')}
          </StyledPageList>
        </div>
      ) : (
        <div />
      )}
      <div>
        <StyledPaginationContainer className={className}>
          <Button
            type={ButtonType.Icon}
            icon={<NavigationAndActionArrowBack />}
            disabled={currentPage === 1}
            onClick={() => {
              onPageChange &&
                onPageChange(currentPage > 1 ? currentPage - 1 : currentPage);
            }}
          />
          <StyledPageList>
            {paginationRange.map((pageNumber, index) => {
              if (pageNumber === DOTS) {
                return (
                  // eslint-disable-next-line react/no-array-index-key
                  <li key={`dots-${index}`} className="dots">
                    &#8230;
                  </li>
                );
              }
              return (
                <li key={pageNumber}>
                  <ToggleButton
                    type={ToggleButtonType.Text}
                    text={pageNumber.toString()}
                    toggled={currentPage === pageNumber}
                    onClick={() =>
                      onPageChange && onPageChange(pageNumber as number)
                    }
                  />
                </li>
              );
            })}
          </StyledPageList>
          <Button
            type={ButtonType.Icon}
            icon={<NavigationAndActionArrowForth />}
            disabled={maxPages === currentPage}
            onClick={() => {
              onPageChange &&
                onPageChange(
                  currentPage < maxPages ? currentPage + 1 : currentPage,
                );
            }}
          />
        </StyledPaginationContainer>
      </div>
    </StyledTableFooter>
  );
};
